import { api } from './client';

export interface GatePass {
  id: number;
  gpNo: string;
  gpDate: string;
  exitTimestamp: string | null;
  expectedReturnDate: string | null;
  isReturnable: boolean;
  invoiceId: number | null;
  outwardGrnId: number | null;
  doId: number | null;
  partyId: number;
  itemsSummary: string | null;
  boxCount: number;
  grossWeightKg: string;
  vehicleNo: string | null;
  driverName: string | null;
  transporterName: string | null;
  transporterGstin: string | null;
  lrNo: string | null;
  ewayBillNo: string | null;
  sealLockNo: string | null;
  gateOfficer: string | null;
  status: 'Active' | 'Closed';
  deliveryStatus: 'In Transit' | 'Delivered' | 'Returned' | null;
  deliveryDate: string | null;
  deliveryRemarks: string | null;
  party?: { id: number; name: string };
  invoice?: { id: number; invoiceNo: string; grandTotal: string };
  dispatchOrder?: { id: number; doNo: string; enquiry?: { enqNo: string } };
}

export async function listGatePasses(filter: {
  status?: string;
  deliveryStatus?: string;
  from?: string;
  to?: string;
  search?: string;
} = {}): Promise<GatePass[]> {
  const r = await api.get<GatePass[]>('/gate-passes', { params: filter });
  return r.data;
}

export async function getGatePass(id: number): Promise<GatePass> {
  const r = await api.get<GatePass>(`/gate-passes/${id}`);
  return r.data;
}

export async function createGatePass(payload: {
  invoiceId: number;
  exitTimestamp?: string;
  sealLockNo?: string;
  gateOfficer?: string;
  isReturnable?: boolean;
  expectedReturnDate?: string;
}): Promise<GatePass> {
  const r = await api.post<GatePass>('/gate-passes', payload);
  return r.data;
}

export async function markDelivered(
  id: number,
  payload: { deliveryDate: string; remarks: string },
): Promise<GatePass> {
  const r = await api.post<GatePass>(`/gate-passes/${id}/mark-delivered`, payload);
  return r.data;
}
